// utils/formTransforms.ts
export function setByPath(obj: any, path: string, value: any) {
  const parts = path.split('.');
  let cur = obj;
  parts.forEach((k, i) => {
    if (i === parts.length - 1) cur[k] = value;
    else cur[k] ??= {};
    cur = cur[k];
  });
}

export function isEmpty(val: any) {
  return val === undefined || val === null || val === '' ||
         (Array.isArray(val) && val.length === 0);
}

export async function applyTransforms(fields: any[], raw: Record<string, any>) {
  const payload: Record<string, any> = {};
  for (const f of fields) {
    const val = raw?.[f.value];

    // Soporta transform async o sync
    if (typeof f.transform === 'function') {
      const out = await f.transform(val, raw);
      if (out && typeof out === 'object') {
        Object.entries(out).forEach(([k, v]) => {
          // Permite dot-path en keys que devuelva el transform
          if (k.includes('.')) setByPath(payload, k, v);
          else payload[k] = v;
        });
      }
      continue;
    }

    // Normalización de arreglos declarativos
    if (f.isJsonArray) {
      const arr = Array.isArray(val) ? val : (isEmpty(val) ? [] : [val]);
      setByPath(payload, f.value, arr);
      continue;
    }

    // Soporta escribir en rutas con punto (p.ej. "additional_data.billing.invoice")
    if (typeof f.value === 'string' && f.value.includes('.')) {
      if (!isEmpty(val)) setByPath(payload, f.value, val);
    } else {
      if (!isEmpty(val)) payload[f.value] = val;
    }
  }
  return payload;
}
